import { objectives, careerOutcomes } from '@/mocks/programData';

export default function About() {
  return (
    <section id="sobre" className="py-20 md:py-28 bg-warm-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <span className="text-accent text-sm font-semibold uppercase tracking-wider">Sobre o Programa</span>
            <h2 className="font-display text-3xl md:text-4xl font-bold text-primary mt-3 mb-4">
              Formação de Excelência em
              <br />
              Educação Médica
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto leading-relaxed">
              O Mestrado em Educação Médica promove a aquisição e desenvolvimento de competências
              pedagógicas e de investigação, particularmente úteis aos profissionais comprometidos
              com a formação das novas gerações.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6 mb-16">
            <div className="bg-white rounded-2xl p-8 hover:shadow-lg transition-shadow">
              <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center mb-5">
                <i className="ri-book-open-line text-primary text-2xl" />
              </div>
              <h3 className="text-lg font-bold text-primary mb-3">Metodologias Ativas</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Aprendizagem baseada em problemas, estudo de casos clínicos e simulação realista,
                preparando docentes para os desafios contemporâneos do ensino médico.
              </p>
            </div>
            <div className="bg-white rounded-2xl p-8 hover:shadow-lg transition-shadow">
              <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center mb-5">
                <i className="ri-team-line text-primary text-2xl" />
              </div>
              <h3 className="text-lg font-bold text-primary mb-3">Corpo Docente Qualificado</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Professores Doutores da UAN e universidades parceiras, com experiência internacional
                em educação médica e investigação científica.
              </p>
            </div>
            <div className="bg-white rounded-2xl p-8 hover:shadow-lg transition-shadow">
              <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center mb-5">
                <i className="ri-award-line text-primary text-2xl" />
              </div>
              <h3 className="text-lg font-bold text-primary mb-3">Certificação UAN</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Diploma emitido pela Universidade Agostinho Neto, reconhecido nacionalmente,
                habilitando ao grau de Mestre em Educação Médica.
              </p>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white rounded-2xl p-8">
              <h3 className="text-xl font-bold text-primary mb-6 flex items-center gap-3">
                <i className="ri-focus-3-line text-accent" />
                Objetivos do Programa
              </h3>
              <ul className="space-y-4">
                {objectives.map((obj, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <span className="w-6 h-6 rounded-full bg-accent/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-accent text-xs" />
                    </span>
                    <span className="text-gray-700 text-sm leading-relaxed">{obj}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="bg-white rounded-2xl p-8">
              <h3 className="text-xl font-bold text-primary mb-6 flex items-center gap-3">
                <i className="ri-briefcase-line text-accent" />
                Perfil de Saída
              </h3>
              <ul className="space-y-4">
                {careerOutcomes.map((outcome, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <span className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-arrow-right-line text-primary text-xs" />
                    </span>
                    <span className="text-gray-700 text-sm leading-relaxed">{outcome}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}